module.exports = __webpack_public_path__ + "img/Lego_Adults_cs.90857c8d.png";